const legends = {
  //red - 8 different legend boards
  1: {
    1: 1,
    2: 2,
    3: 3,
  },
  2: {
    2: 2,
    3: 3,
    4: 5,
  },
  3: {
    3: 3,
    4: 5,
    5: 10,
  },
  4: {
    1: 1,
    2: 2,
    5: 10,
  },
  5: {
    1: 1,
    2: 2,
    4: 5,
  },
  6: {
    1: 1,
    3: 3,
    5: 10,
  },
  7: {
    1: 1,
    4: 5,
    5: 10,
  },
  8: {
    2: 2,
    3: 3,
    5: 10,
  },
  //blue - 8 different legend boards
  9: {
    6: 1,
    7: 2,
    8: 3,
  },
  10: {
    7: 2,
    8: 3,
    9: 5,
  },
  11: {
    8: 3,
    9: 5,
    10: 10,
  },
  12: {
    6: 1,
    7: 2,
    10: 10,
  },
  13: {
    6: 1,
    7: 2,
    9: 5,
  },
  14: {
    6: 1,
    8: 3,
    10: 10,
  },
  15: {
    6: 1,
    9: 5,
    10: 10,
  },
  16: {
    7: 2,
    9: 5,
    10: 10,
  },
  //red - 4 dinos per legend board. 5 different boards. can increase point value if we want too.
  17: {
    1: 1,
    2: 2,
    3: 3,
    4: 5,
  },
  18: {
    1: 1,
    2: 2,
    3: 3,
    5: 10,
  },
  19: {
    1: 1,
    2: 2,
    4: 5,
    5: 10,
  },
  20: {
    1: 1,
    3: 3,
    4: 5,
    5: 10,
  },
  21: {
    2: 2,
    3: 3,
    4: 5,
    5: 10,
  },
  //blue - 4 dinos per legend board. 5 different boards.
  22: {
    6: 1,
    7: 2,
    8: 3,
    9: 5,
  },
  23: {
    6: 1,
    7: 2,
    8: 3,
    10: 10,
  },
  24: {
    6: 1,
    7: 2,
    9: 5,
    10: 10,
  },
  25: {
    6: 1,
    8: 3,
    9: 5,
    10: 10,
  },
  26: {
    7: 2,
    8: 3,
    9: 5,
    10: 10,
  },
  //red - 3 dinos with 4th as subtraction operand.
  27: {
    1: 1,
    2: 2,
    3: 3,
    11: -5,
  },
  28: {
    2: 2,
    3: 3,
    4: 5,
    12: -10,
  },
  29: {
    3: 3,
    4: 5,
    5: 10,
    13: -3,
  },
  30: {
    1: 1,
    2: 2,
    5: 10,
    14: -2,
  },
  31: {
    1: 1,
    2: 2,
    4: 5,
    15: -1,
  },
  //blue - 3 dinos with 4th as subtraction operand.
  32: {
    6: 1,
    7: 2,
    8: 3,
    14: -2,
  },
  33: {
    7: 2,
    8: 3,
    9: 5,
    11: -5,
  },
  34: {
    8: 3,
    9: 5,
    10: 10,
    12: -10,
  },
  35: {
    6: 1,
    7: 2,
    10: 10,
    13: -3,
  },
  36: {
    6: 1,
    7: 2,
    9: 5,
    15: -1,
  },
};

export default legends;
